import { render } from "./CustomOssUploader.vue?vue&type=template&id=3262ee18"
import script from "./CustomOssUploader.vue?vue&type=script&lang=js"
export * from "./CustomOssUploader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__